import React, { useEffect, useState } from "react";
 
const url = process.env.REACT_APP_API_BASE_GEOSERVER;
function Overview() { 
    const [iframeHeight, setIframeHeight] = useState(window.innerHeight - 100);
  
    useEffect(() => {
      const updateHeight = () => {
        const availableHeight = window.innerHeight - 185;
        setIframeHeight(availableHeight);
      };
  
      updateHeight();
      window.addEventListener("resize", updateHeight);
  
      return () => window.removeEventListener("resize", updateHeight);
    }, []);
  return (
    <div>
      <iframe
        src={`${url}/ov.php`}
        width="100%"
        height="1100px"
        style={{ border: "none" }}
        title="Dynamic Iframe"
      />
    </div>
  );
}

export default Overview;
